import { PreVettingStep4Screen } from "@/features/vendor/pre-vetting";

export default PreVettingStep4Screen;
